// Stable, revalidated entry point. The application/CSS are hashed dynamic chunks.
const fallback = document.getElementById('btl-blog-header-fallback');
const client = document.getElementById('btl-blog-header-client');

if (fallback && client) {
    client.hidden = true;
    import('./client.jsx').then(({ mountBlogHeader }) => {
        mountBlogHeader({ fallback, client });
    }).catch(() => {
        fallback.hidden = false;
        client.hidden = true;
        console.warn('Blog navigation could not be enhanced; ordinary links remain available.');
    });
}
